import { render, staticRenderFns } from "./PortalRadio.vue?vue&type=template&id=5f27f5f2&scoped=true&"
import script from "./PortalRadio.vue?vue&type=script&lang=ts&"
export * from "./PortalRadio.vue?vue&type=script&lang=ts&"
import style0 from "./PortalRadio.vue?vue&type=style&index=0&id=5f27f5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f27f5f2",
  null
  
)

export default component.exports